import { Component, Input } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'modal-component',
    templateUrl: './modal.component.html'
})
export class ModalComponent {
    @Input()
    public titleLabel: string;

    @Input()
    public set content(content: string) {
        this.bodyContent = this.domSanitizer.bypassSecurityTrustHtml(content);
    }

    @Input()
    public buttonLabel: string;

    public bodyContent: SafeHtml;

    constructor(
        private domSanitizer: DomSanitizer,
        private activeModal: NgbActiveModal
    ) {}

    public closeModal(): void {
        this.activeModal.close();
    }
}
